'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpButton = exports.HelpText = exports.isOpen = exports.reducer = exports.toggle = exports.NAME = undefined;
var _reactRedux = require('react-redux');
var _helpButton = require('./components/help-button');
var _helpButton2 = _interopRequireDefault(_helpButton);
var _helpText = require('./components/help-text');
var _helpText2 = _interopRequireDefault(_helpText);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NAME = exports.NAME = 'helpInfo';

// action types
var TOGGLE = NAME + '/OPEN';

// actions
var toggle = exports.toggle = function toggle(id) {
  return {
    type: TOGGLE,
    id: id
  };
};

// reducer
var reducer = exports.reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    id: ''
  };
  var action = arguments[1];
  switch (action.type) {
    case TOGGLE:
      {
        if (state.id === action.id) {
          return {
            id: ''
          };
        }
        return {
          id: action.id
        };
      }
    default:
      return state;
  }
};

// selectors
var isOpen = exports.isOpen = function isOpen(state, id) {
  return state[NAME].id === id;
};

// containers
var HelpTextContainer = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    open: isOpen(state, ownProps.id)
  };
}, function (dispatch, ownProps) {
  return {
    onClick: function onClick() {
      return dispatch(toggle(ownProps.id));
    }
  };
})(_helpText2.default);
var HelpButtonContainer = (0, _reactRedux.connect)(undefined, function (dispatch, ownProps) {
  return {
    onClick: function onClick() {
      return dispatch(toggle(ownProps.id));
    }
  };
})(_helpButton2.default);
exports.HelpText = HelpTextContainer;
exports.HelpButton = HelpButtonContainer;